import { createContext, useContext } from 'react';

export const DrawerScrollContext = createContext<HTMLDivElement | null>(null);

export const useDrawerScrollElement = () => useContext(DrawerScrollContext);
